'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { getNormalizedFields } from 'DesignData/helpers/customWidgetFieldsHelper';
import CustomWidgetBuffer from 'DesignData/models/CustomWidgetBuffer';
import CustomWidgetTranslations from 'DesignData/models/CustomWidgetTranslations';
import { CUSTOM_WIDGET_REVISIONS_FETCH, CUSTOM_WIDGET_BUFFER_DELETE, CUSTOM_WIDGET_REVISION_FETCH } from 'DesignData/actions/ActionTypes';

const getTranslations = revisionData => {
  const {
    masterLanguage,
    messages
  } = revisionData;
  return masterLanguage && messages ? new CustomWidgetTranslations({
    masterLanguage,
    messages
  }) : {
    masterLanguage: null,
    messages: {}
  };
};

function revisions(state = SeamlessImmutable({
  revisions: {}
}), action) {
  switch (action.type) {
    case CUSTOM_WIDGET_REVISIONS_FETCH:
      {
        const {
          revisions: revs
        } = action;

        if (!revs) {
          return state;
        }

        revs.forEach(revision => {
          if (revision.id !== -1 && state.revisions[revision.id]) {
            /* Already downloaded the revision, no need to do it again */
            return;
          }

          const revisionData = new CustomWidgetBuffer(revision.object);
          const revisionFields = getNormalizedFields(revisionData.fields, true);
          state = state.setIn(['revisions', revision.id], {
            buffer: revisionData.without('fields'),
            fields: revisionFields,
            translations: getTranslations(revisionData)
          });
        });
        return state;
      }

    case CUSTOM_WIDGET_REVISION_FETCH:
      {
        const {
          customWidget,
          revisionId
        } = action;

        if (!(customWidget && revisionId)) {
          return state;
        }

        if (revisionId !== -1 && state.revisions[revisionId]) {
          return state;
        }

        const revisionData = new CustomWidgetBuffer(customWidget);
        const revisionFields = getNormalizedFields(revisionData.fields, true);
        state = state.setIn(['revisions', revisionId], {
          buffer: revisionData.without('fields'),
          fields: revisionFields,
          translations: getTranslations(revisionData)
        });
        return state;
      }

    default:
      return state;
  }
}

function byId(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case CUSTOM_WIDGET_REVISIONS_FETCH:
    case CUSTOM_WIDGET_REVISION_FETCH:
      {
        const customWidgetId = action.customWidgetId || action.resourceId;
        return state.set(customWidgetId, revisions(state[customWidgetId], action));
      }

    case CUSTOM_WIDGET_BUFFER_DELETE:
      {
        const {
          customWidgetId
        } = action;
        return state.without(customWidgetId);
      }

    default:
      return state;
  }
}

export default combineReducers({
  byId
});